import { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { BigButton } from "../../components/kyc/KycShell";

const TIPOS = [["acceso", "Ver qué datos míos tienen"], ["rectificacion", "Corregir mis datos"], ["supresion", "Borrar mis datos"], ["oposicion", "Oponerme a un uso de mis datos"]];

export default function DerechosTitular() {
  const { slug } = useParams();
  const [f, setF] = useState({ tipo: "acceso", nombre: "", documento: "", correo: "", detalle: "" });
  const [ok, setOk] = useState(null);
  const send = async (e) => {
    e.preventDefault();
    try {
      const r = await api.post(`/public/k/${slug}/solicitudes-titular`, f);
      setOk(r.data.mensaje);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  if (ok) return <p className="max-w-xl mx-auto p-6 text-lg" data-testid="titular-public-ok">{ok}</p>;
  const inp = "w-full min-h-[48px] border-2 border-slate-300 rounded-lg px-3 text-base";
  return (
    <form onSubmit={send} className="max-w-xl mx-auto p-6 space-y-4" data-testid="titular-public-form">
      <h1 className="font-heading text-2xl font-bold">Tus derechos sobre tus datos</h1>
      <select className={inp} value={f.tipo} onChange={(e) => setF({ ...f, tipo: e.target.value })} data-testid="titular-public-tipo">
        {TIPOS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      {[["nombre", "Nombre completo"], ["documento", "Número de documento"], ["correo", "Correo para responderte"]].map(([k, l]) => (
        <input key={k} required className={inp} placeholder={l} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`titular-public-${k}`} />
      ))}
      <textarea required className={`${inp} min-h-[100px] py-2`} placeholder="Cuéntanos tu solicitud" value={f.detalle} onChange={(e) => setF({ ...f, detalle: e.target.value })} data-testid="titular-public-detalle" />
      <BigButton type="submit" data-testid="titular-public-submit">Enviar solicitud</BigButton>
    </form>
  );
}
